import React, { useEffect, useRef } from 'react';

const PayPalButton = ({ amount, description, onSuccess, onError }) => {
  const paypalRef = useRef();

  useEffect(() => {
    const renderButton = () => {
      if (window.paypal && paypalRef.current) {
        if (paypalRef.current.hasChildNodes()) {
          paypalRef.current.innerHTML = ''; 
        }

        window.paypal.Buttons({
          style: {
            layout: 'vertical', 
            color: 'blue',      
            shape: 'rect',      
            label: 'paypal',    
          },
          createOrder: (data, actions) => {
            return actions.order.create({
              purchase_units: [{
                description: description,
                amount: {
                  currency_code: 'USD',
                  value: amount, 
                },
              }],
            }).then(orderId => {
              return orderId;
            }).catch(err => {
              onError(new Error('Error al crear la orden de PayPal.'));
              return Promise.reject(err); 
            });
          },
          onApprove: async (data, actions) => {
            try {
              const order = await actions.order.capture();
              onSuccess(order);
            } catch (error) {
              onError(new Error('Error al capturar el pago de PayPal.'));
            }
          },
          onCancel: (data) => {
            onError(new Error('Pago de PayPal cancelado.'));
          },
          onError: (err) => {
            onError(new Error('Ocurrió un error con PayPal. Por favor, inténtalo de nuevo o contacta a soporte.'));
          },
        }).render(paypalRef.current);
      } else if (!window.paypal) {
        onError(new Error('PayPal SDK no cargado.'));
      }
    };

    renderButton();

  }, [amount, description, onSuccess, onError]);

  return (
    <div ref={paypalRef} className="w-full">
    </div>
  );
};

export default PayPalButton;

// DONE